module.exports = __webpack_public_path__ + "static/media/LogoMissCi.6544fdf4.png";